module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-0-7bb407824fe0b30e4f9b168dbc0b0e24.jpg";